import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updateTime()
    this.interval = setInterval(() => {
      this.updateTime()
    }, 1000)
  }

  updateTime() {
    this.element.textContent = new Date().toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit', second: '2-digit'})
  }

  disconnect() {
    clearInterval(this.interval)
  }
}
